// SignOutCallback.js
import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { oidcLogoutCallback } from '../../slices/thunks';
import { MoonLoader } from 'react-spinners';

const SignOutCallback = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Guard: signout callback hanya boleh diproses SATU kali — tanpa ini
  // panggilan kedua ke signoutRedirectCallback() throw "No matching state"
  // dan callback gagal (pola sama dengan SigninOidc).
  const called = useRef(false);
  useEffect(() => {
    if (called.current) return;
    called.current = true;
    dispatch(oidcLogoutCallback(navigate));
  }, [dispatch, navigate]);

  return (
    <div className='loading-container'>
      <MoonLoader color='#3498db' loading={true} size={50} />
      <p>Processing logout...</p>
    </div>
  );
};

export default SignOutCallback;
